import React, { Component } from 'react';
import axios from 'axios';
import '../Asset/Css/style.bundle.css';
import '../Asset/custom.css';
import { Link } from 'react-router-dom';
import global from './global';
import { config } from '../Constants';
import { Layout } from './Layout';
import Spinner from '../components/Spinner';
import BenImg from '../Asset/demo/default/media/img/misc/Shareholders.png';
import Form15GHImg from '../Asset/demo/default/media/img/misc/Form-15-GH.png';
import Part2Img from '../Asset/demo/default/media/img/misc/Part-2-Details.png';
import AssImg from '../Asset/demo/default/media/img/misc/Assignments.png';
import ReportImg from '../Asset/demo/default/media/img/misc/Reports.png';
import ProfileImg from '../Asset/demo/default/media/img/misc/User-Profile.png';
import queryString from 'query-string';
import ReactNotification from 'react-notifications-component';
import { store } from 'react-notifications-component';
import { Row, Col, InputGroup, FormControl } from 'react-bootstrap';
import {
    Card,
    Alert,
    CardBody,
    NavItem,
    NavLink,
    Nav,
    TabContent,
    TabPane, Modal, ModalHeader, ModalBody, ModalFooter
} from "reactstrap";
export class Home extends Component {
    static displayName = 'Easy Dividend';

    constructor(props) {
        super(props);

        this.state = {
            collapsed: true,
            token: '',
            Loading: false,
            EmailID: '',
            RemitterName: '',
            RemitterID: '',
            URL: config.url.Web_URL,
            showCookieModal: false,
            IsAgreeTerms: 0
        };
    }

    showNoti(title, message, type) {

        store.addNotification({
            title: title,
            message: message,
            type: type,
            insert: "top",
            container: "top-right",
            animationIn: ["animate__animated", "animate__fadeIn"],
            animationOut: ["animate__animated", "animate__fadeOut"],
            dismiss: {
                duration: 10000,
                onScreen: true
            }
        });

    };

    modalCloseSave() {
        if (this.state.IsAgreeTerms == "1") {
            window.location.reload(true);
            this.setState({
                showCookieModal: false
            });
        }
        else {
            this.showNoti("Notification", "You must agree to Terms of Use and Privacy Notice.", "danger");
            this.setState({
                showCookieModal: true
            });
        }
    }

    render() {
        if (this.state.Loading) return <Spinner />;
        let content = Layout.RenderNavMenu();
        let contentSideBar = Layout.RenderSideBar();
        let contentFooter = Layout.RenderFooter();
        return (
            <div>
                <ReactNotification />
                <Modal isOpen={this.state.showCookieModal} size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered>
                    <ModalHeader><b>Terms of Use and Privacy Notice</b></ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col md={12} className="session-modal-text">
                                We Nexdigm Private Limited  (<b>"Company"</b>, <b>"we"</b> or <b>"us"</b> or <b>"our"</b>) are the owners of web based application namely https://easydividend.nexdigm.com/Nexdigm referred to as (the <b>"Platform"</b>). The Platform enables users to submit online forms, declarations etc. in relation to dividend and other tax related services online and avail such other services (the <b>"Services"</b>). Please read these Terms of Use and Privacy Notice collectively referred to as (the <b>"Terms"</b>) carefully before using or accessing the Platform and/or availing the Services. By accessing the Platform and/or availing the Services you accept and agree to the Terms. These Terms constitute a legally binding agreement between you and the Company.  Collection of Personal Information- To avail the Services, you agree and provide your consent to our collection of your personal information including but not limited to your name, PAN number, email address, contact number and physical address (<b>"Personal Information"</b>). You shall be solely responsible for the accuracy, correctness, or truthfulness of the Personal Information submitted on the Platform.
                                <br /><br />
                                1.	<b>Non-Disclosure of Personal Information-</b> We shall not disclose your Personal Information to any person or make use of or take advantage of the Personal Information for any purpose other than as specifically permitted by these Terms. Notwithstanding the foregoing, to provide you the Services, we may share your Personal Information with our affiliates, sub-contractors, service providers of the company in which you are the shareholder and with the regulatory authorities to comply with our legal obligations.
                                <br />
                                2.	<b>Accessing and Modifying Personal Information-</b> To access or to modify your Personal Information, you may send your request for such access and modification to the company in which you are the shareholder or to the concerned registrar and share transfer agent (RTA).
                                <br />
                                3.	<b>Data Retention-</b> We will retain your Personal Information for a duration as required to provide you the Services and thereafter to comply with our legal and statutory requirements.
                                <br />
                                4.	<b>Data Security-</b> Your Personal Information will be stored on third party cloud servers. Although we have implemented reasonable and appropriate safeguards to prevent unauthorized access, unlawful processing or accidental loss or destruction of Personal Information we cannot warrant the security of any Personal Information transmitted as these systems are not hack proof. Data pilferage due to unauthorized hacking, virus attacks or the like cannot always be prevented and we assume no liability or responsibility for it.
                                <br />
                                5.	<b>Restrictions-</b> You will not use the Platform and/or the Services for any illegal purpose or in violation of any local, state, national, or international laws. You may not use the Platform in any manner that could disable, overburden, damage, or impair the Platform or interfere with any other user's use and enjoyment of the Platform. You must not misuse the Platform, attempt to gain unauthorized access to the Platform or any server, computer or database connected to our Platform.
                                <br />
                                6.	<b>Disclaimers- YOU EXPRESSLY ACKNOWLEDGE AND AGREE THAT USE OF THE PLATFORM AND THE SERVICES PROVIDED THROUGH IT IS ENTIRELY AT YOUR OWN RISK AND THAT THE PLATFORM AND THE INFORMATION THEREIN ARE PROVIDED ON AN "AS IS" OR "AS AVAILABLE" BASIS, WITHOUT ANY WARRANTIES OF ANY KIND. ALL EXPRESS AND IMPLIED WARRANTIES, INCLUDING, WITHOUT LIMITATION, THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT OF PROPRIETARY RIGHTS ARE EXPRESSLY DISCLAIMED TO THE FULLEST EXTENT PERMITTED BY LAW. THE COMPANY MAKES NO WARRANTIES OR REPRESENTATIONS ABOUT THE ACCURACY OR COMPLETENESS OF THE SERVICES OR ANY INFORMATION INCLUDING PERSONAL INFORMATION PROVIDED OR THE PLATFORM'S CONTENT OR THE DATA SHARED BY OR THE CONTENT OF ANY THIRD PARTY LINKED WEBSITE TO THE PLATFORM AND ASSUMES NO LIABILITY OR RESPONSIBILITY FOR ANY ERRORS, MISTAKES, OR INACCURACIES OF CONTENT.</b>
                                <br />
                                7.	<b>Limitation of Liability-</b> In no event, shall the Company, affiliates, subcontractors, service providers be liable for any direct, indirect, punitive, incidental, special or consequential damages or for any damages whatsoever arising out of or in connection with your use, or inability to use, the Platform and the Services, loss of data, access to any third party websites, any content on the Platform or such other third party websites or any services obtained through such other third party websites. The foregoing does not affect any liability which cannot be excluded or limited under applicable laws.
                                <br />
                                8.	<b>Termination-</b> The Company reserves the right to terminate your right and access to use the Platform and the Services upon your material breach of these Terms.
                                <br />
                                9.	<b>Governing Laws-</b> These Terms and Your use of the Platform and Services is governed by, construed and enforced in accordance with the laws of India and, for the purposes of any legal or equitable actions, you specifically agree and submit to the exclusive jurisdiction and venue of the Courts of Mumbai.
                                <br />
                                10.	<b>Change in Terms-</b> Please revisit this page periodically to stay aware of any changes to these Terms which we may update from time to time. If we modify these Terms, we will make it available through the Platform and indicate the date of the latest revision.
                                These Terms were last modified on June 23, 2021.
                                <br />
                                11.	<b>Contact us-</b> If you have any questions or concerns or grievances regarding these Terms, you can email us your concerns to dividend.support@nexdigm.com.
                                <br />  <br />
                            </Col>
                             
                            <Col md={12} className="session-modal-text">
                                    <input id="isagree" type="checkbox" onClick={e => this.handleTermsCheckbox(e)}/>
                                    <label>
                                       <b> Agree to Terms of Use and Privacy Notice </b>
                                    </label>
                            </Col>
                           
                        </Row>
                    </ModalBody>
                    <ModalFooter>
                        <a href="https://www.nexdigm.com/" className="headersClientNew" style={{
                            backgroundImage: `url(${process.env.PUBLIC_URL + "/Images/nexdigm-logo.png"})`
                        }}></a>
                        <button className="btn btn-primary m-l-10" type="button" onClick={e => this.modalCloseSave(e)}>Continue</button>
                    </ModalFooter>
                </Modal>
                <div className="m-grid m-grid--hor m-grid--root m-page">
                    {content}
                    <div className="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-body">

                        <div className="m-grid__item m-grid__item--fluid m-wrapper">
                            <div className="m-subheader " >
                                <div className="d-flex align-items-center">
                                    <div className="mr-auto">
                                        <h3 className="m-subheader__title ">
                                            My Access
								    </h3>
                                    </div>
                                </div>
                            </div>

                            <div className="m-content">
                                <div className="row">
                                    <div className="col-xl-3 col-md-6 col-lg-3 col-sm-12">
                                        <a href={this.state.URL + "/Nexdigm/Assignment"}>
                                            <div className="m-portlet m-portlet--bordered-semi m-portlet--full-height text-center gradient-bg">
                                                <div className="m-portlet__body">
                                                    <img src={AssImg} />
                                                </div>
                                                <div className="m-portlet__footer">
                                                    <div className="m-portlet__footer-caption">
                                                        <div className="m-portlet__footer-title">
                                                            <h3 className="m-portlet__footer-text text-center">
                                                                Assignments
                                                            </h3>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                    <div className="col-xl-3 col-md-6 col-lg-3 col-sm-12">
                                        <a href={this.state.URL + "/Nexdigm/Shareholder-Details"}>
                                            <div className="m-portlet m-portlet--bordered-semi m-portlet--full-height text-center gradient-bg">
                                                <div className="m-portlet__body">
                                                    <img src={BenImg} />
                                                </div>
                                                <div className="m-portlet__footer">
                                                    <div className="m-portlet__footer-caption">
                                                        <div className="m-portlet__footer-title">
                                                            <h3 className="m-portlet__footer-text text-center">
                                                                Shareholders
                                                            </h3>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                    <div className="col-xl-3 col-md-6 col-lg-3 col-sm-12">
                                        <a href={this.state.URL + "/Nexdigm/Part2"}>
                                            <div className="m-portlet m-portlet--bordered-semi m-portlet--full-height text-center gradient-bg">
                                                <div className="m-portlet__body">
                                                    <img src={Part2Img} />
                                                </div>
                                                <div className="m-portlet__footer">
                                                    <div className="m-portlet__footer-caption">
                                                        <div className="m-portlet__footer-title">
                                                            <h3 className="m-portlet__footer-text text-center">
                                                                Part 2 Details
                                                            </h3>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </a>
                                    </div>

                                    <div className="col-xl-3 col-md-6 col-lg-3 col-sm-12">
                                        <a href={this.state.URL + "/Nexdigm/Report"}>
                                            <div className="m-portlet m-portlet--bordered-semi m-portlet--full-height text-center gradient-bg">
                                                <div className="m-portlet__body">
                                                    <img src={ReportImg} />
                                                </div>
                                                <div className="m-portlet__footer">
                                                    <div className="m-portlet__footer-caption">
                                                        <div className="m-portlet__footer-title">
                                                            <h3 className="m-portlet__footer-text text-center">
                                                                Reports
                                                            </h3>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {contentFooter}
                </div>
            </div>
        );
    }
}

